import { createRoot } from 'react-dom/client'
import { NewProductWidget } from './NewProductWidget.jsx'

const selector = '[data-nova-new-product]'

function parsePayload(element) {
  try {
    return JSON.parse(element.dataset.payload || '{}')
  } catch {
    return {}
  }
}

function mountNewProductWidget(element) {
  if (element.__novaReactRoot) return

  element.__novaReactRoot = createRoot(element)
  element.__novaReactRoot.render(<NewProductWidget payload={parsePayload(element)} />)
}

function mountNewProductWidgets(root = document) {
  if (root.matches?.(selector)) {
    mountNewProductWidget(root)
  }

  root.querySelectorAll?.(selector).forEach(mountNewProductWidget)
}

mountNewProductWidgets()

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        mountNewProductWidgets(node)
      }
    })
  })
})

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
})
